































































import { Component, Prop, Vue } from "vue-property-decorator";
import { Product } from "../types/DataSource";
import Headline from "./Headline.vue";
import ProductItem from "./ProductItem.vue";

@Component({
  components: {
    Headline,
    ProductItem
  }
})
export default class ProductList extends Vue {
  @Prop() private products!: Product[];

  private productSortType = "sort-by-price-asc";

  get topMatch(): Nullable<Product> {
    if (this.productsPerfect.length > 0) {
      return this.productsPerfect[0];
    } else if (this.productsGood.length > 0) {
      return this.productsGood[0];
    } else if (this.products.length > 0) {
      return this.products[0];
    }

    return null;
  }

  get productsPerfect() {
    return this.products.filter(product => product.match == "perfect");
  }

  get productsGood() {
    return this.products.filter(
      product => product.match == "good" || product.match == "well"
    );
  }

  get otherRecommendedProducts() {
    const otherProducts = this.productsGood;

    switch (this.productSortType) {
      case "sort-by-price-asc":
        return otherProducts.sort(
          (product1, product2) => product1.price - product2.price
        );

      case "sort-by-price-desc":
        return otherProducts.sort(
          (product1, product2) => product2.price - product1.price
        );
    }

    return otherProducts;
  }

  get customVuexStyles() {
    return {
      "--font-main": this.$store.state.globalCss.font.fontName
    };
  }
}
